module.exports = __webpack_public_path__ + "img/Group2.29dff169.png";